import React, { Fragment, useEffect, useState } from "react";
import "../../AdminScreens/AttendanceSheet/AttendanceSheet.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import axios from "axios";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Header from "../../../Components/Dashboard/Header/Header";
import { Apiurl, GetToken, RemoveUserSession } from "../../../Utils/utils";
import moment from "moment";
import fullday from "../../../Assets/Images/Present.png";
import holiday from "../../../Assets/Images/SatSun.png";
import leave from "../../../Assets/Images/FullDayLeave.png";
import shortleave from "../../../Assets/Images/shortleaveiconnew.png";
import HalfDayLeave from "../../../Assets/Images/HalfDayLeave.png";
import Properholiday from "../../../Assets/Images/Holiday.png";
import OutDoorLeave from "../../../Assets/Images/OutDoorDuty.png"
import SickLeave from "../../../Assets/Images/SL.png"
import CasualLeave from "../../../Assets/Images/CLstar.png"
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Components/loader/loader";
import { FaEdit } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import { Button, Offcanvas } from "react-bootstrap";
import { IoIosFunnel } from "react-icons/io";
function OffCanvasExample({setShow,show, setActiveButton, handleAttendanceSearch,currentDate,setSearchAttendance,searchAttendance, activeButton ,name, ...props }) {

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="HideButton-on-web" variant="primary" onClick={handleShow} >
      <IoIosFunnel />
      </Button>
      <Offcanvas className="Offcanvas-main-container" show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header className="Offcanvas-outter-container" closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="Offcanvas-Body-container">
        <div className="Offcanvas-close-popup-forEMp-attendance">
  <div className="Offcanvas-Div" onClick={handleClose}></div>
          </div>
      
              <div className="calender-in-header-for-mobile-view row ">
                <div className="col-4">
                  <div className="EMP-flash-floating-sheet col">
                    <label htmlFor=""> Choose start date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          startDate: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="flash-floating-sheet col">
                    <label htmlFor=""> Choose end date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.endDate}
                      // min={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          endDate: e?.target?.value,
                        })
                      }
                      min={searchAttendance?.startDate}
                      max={currentDate}
                    />
                  </div>
                </div>
                {activeButton ||
                (searchAttendance?.startDate && searchAttendance?.endDate) ? (
                  <div className=" EMP-search-button-sheet col-4">
                    <button
                      onClick={() => {
                        setSearchAttendance({
                          startDate: "",
                          endDate: "",
                          dayscount: "",
                        });
                        setActiveButton();
                        handleAttendanceSearch();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                ) : null}
              </div> 
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
const AttendanceSheet = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchAttendance, setSearchAttendance] = useState({
    startDate: "",
    endDate: "",
  });
  const [show, setShow] = useState(false);

  const currentDate = new Date().toISOString().split("T")[0];
  const todayDate = moment(new Date()).format("YYYY-MM-DD");
  const [activeButton, setActiveButton] = useState();
  const [monthResult, setMonthResult] = useState();
  console.log(monthResult,"monthResult");
  const [showSidebar, setShowSidebar] = useState(true);
  const LoginToken = GetToken();
  const [getAttendance, setGetAttendance] = useState();
  const [dummyData, setDummyData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [Modaldata, setmodaldata] = useState();
  const [modaldatanew, setmodaldatanew] = useState("");
  const [updateAttend, setupdateAttend] = useState("");
  console.log(updateAttend,"updateAttend");
  const [DailyStatuscheck, setDailyStatuscheck] = useState("")

  const handlePencilClick = (item) => {
    setupdateAttend(item);
    const timeToString = (e) => {
      if (e === undefined || e === null) {
        return null;
      }
      const timeString = e;
      const timeArray = timeString?.split(":");
      if (timeArray === undefined || timeArray === null) {
        return null;
      }
      const date = new Date();
      date.setHours(parseInt(timeArray[0], 10));
      date.setMinutes(parseInt(timeArray[1], 10));
      date.setSeconds(parseInt(timeArray[2], 10));
      return date;
    };
    const inTime = timeToString(item.InTime);
    const outTime = timeToString(item.OutTime);
    setmodaldata(inTime);
    setmodaldatanew(outTime);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleAttendanceSearch = (e) => {
    if (searchAttendance?.endDate < searchAttendance?.startDate) {
      toast.error("end date should grater than start date");
      setSearchAttendance({
        ...searchAttendance,
        endDate: "",
      });
      return;
    }
    setLoading(true);
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );

    const formattedStartDate = firstDayOfMonth.toISOString().split('T')[0];
    const formattedEndDate = currentDate.toISOString().split('T')[0];  
      const data = {
      startDate:
        searchAttendance?.startDate || formattedStartDate || e?.startDate || "",
      endDate:
      searchAttendance?.endDate || formattedEndDate || e?.endDate || "",

    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetAttendance`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setShow(false)
        if (response?.status === 200) {
          const data = JSON.parse(response?.data?.data);

          setGetAttendance(data);
          const oldData = data?.reduce((result, currentItem) => {
            const date = new Date(currentItem.Date);
            const month = date.getMonth() + 1;
            result[month - 1] = result[month - 1] || [];
            result[month - 1].push(currentItem);
            return result;
          }, []);

          const newData = oldData?.map((item) => {
            const value = item?.reduce((result, currentItem) => {
              const userId = currentItem.UserId;
              result[userId - 1] = result[userId - 1] || [];
              result[userId - 1].push(currentItem);
              return result;
            }, []);
            setDummyData(value);
          });
          if (e?.status === 200) {
            toast.success(e?.data?.message);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
        if (
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  useEffect(() => {
    if (dummyData) {
      const finalData = dummyData?.filter((item) => item?.length > 0);
      finalData.sort((a, b) => {
        const monthA = new Date(a[0].Date).getMonth();
        const monthB = new Date(b[0].Date).getMonth();
        const dayA = new Date(a[0].Date).getDate();
        const dayB = new Date(b[0].Date).getDate();
        if (monthA === monthB) {
          return dayB - dayA;
        }
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth();
        if (monthA === currentMonth) {
          return -1;
        } else if (monthB === currentMonth) {
          return 1;
        }
        return monthB - monthA;
      });
      setMonthResult(finalData);
    }
  }, [dummyData]);

  useEffect(() => {
    if (searchAttendance?.startDate && searchAttendance?.endDate) {
      setActiveButton(1);
      const data = {
        startDate: searchAttendance?.startDate,
        endDate: searchAttendance?.endDate,
        dayscount: "",
      };
      handleAttendanceSearch();
    } else {
      handleAttendanceSearch();
    }
  }, [searchAttendance?.endDate]);

  const monthsArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  useEffect(() => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    // setCurrentMonthAndYear(`${monthsArray[currentMonth]} ${currentYear}`);
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleUpdateAttendance = () => {
    const data = {};
    data.Id = updateAttend.Id;
    data.UserName = updateAttend?.User?.UserName;
    data.InTime = moment(new Date(Modaldata)).format("HH:mm:ss.SS");
    data.OutTime = moment(new Date(modaldatanew)).format("HH:mm:ss.SS");
    data.Date = updateAttend.Date;
    const inTime = moment(Modaldata, "HH:mm:ss.SS");
    const outTime = moment(modaldatanew, "HH:mm:ss.SS");
    const durationInMilliseconds = outTime.diff(inTime);
    const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((durationInMilliseconds % (1000 * 60)) / 1000);
    const milliseconds = durationInMilliseconds % 1000;
    const workDuration = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    data.WorkDuration = workDuration;
    if (data.InTime && data.OutTime) {
      data.Status = "Present";
    } else {
      data.Status = "Absent";
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowModal(false);
          handleAttendanceSearch();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };


  // const handlecheck = (e) => {
  //   if (searchAttendance?.endDate < searchAttendance?.startDate) {
  //     toast.error("end date should grater than start date");
  //     setSearchAttendance({
  //       ...searchAttendance,
  //       endDate: "",
  //     });
  //     return;
  //   }
  //   setLoading(true);
  //   const currentDate = new Date();
  //   const firstDayOfMonth = new Date(
  //     currentDate.getFullYear(),
  //     currentDate.getMonth(),
  //     1
  //   );

  //   const formattedStartDate = firstDayOfMonth.toLocaleDateString();
  //   const data = {
  //     startDate:
  //       searchAttendance?.startDate || formattedStartDate || e?.startDate || "",
  //     endDate:
  //       searchAttendance?.endDate ||
  //       currentDate.toLocaleDateString() ||
  //       e?.endDate ||
  //       "",
  //   };

  //   setLoading(true);
  //   const option = {
  //     method: "POST",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       authorization: `Bearer ${LoginToken}`,
  //     },
  //     url: `${Apiurl()}/Admin/GetAttendanceByDateAdmin`,
  //     data: { data: JSON.stringify(data) },
  //   };
  //   axios(option)
  //     .then((e) => {
  //       setLoading(false);
  //       if (e?.status === 200) {
  //         toast.success(e?.data?.message);
  //         const data = JSON.parse(e.data.data)
  //         setDailyStatuscheck(data);

  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error(error?.response?.data?.message);
  //     });
  // };

  // useEffect(() => {
  //   if (searchAttendance?.startDate && searchAttendance?.endDate) {
  //     setActiveButton(1);
  //     const data = {
  //       startDate: searchAttendance?.startDate,
  //       endDate: searchAttendance?.endDate,
  //     };
  //     handlecheck();
  //   } else {
  //     handlecheck();
  //   }
  // }, [searchAttendance?.endDate]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div>
        <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
        <div className="d-flex">
          <Sidebar showSidebar={showSidebar} />
          <div
            className={
              showSidebar
                ? "EMP-main-container-of-all-employees-sheet-hr"
                : "EMP-main-container-of-all-employees-page-new-sheet"
            }
          >
            <div className="EMP-inner-container-of-all-employees-page ">
              <div className="header-of-employees-page row">
                <div className="EMP-all-employee-sheet col">
                  <h4>Employee Attendance Sheet</h4>
                  <OffCanvasExample currentDate={currentDate} setActiveButton={setActiveButton} handleAttendanceSearch={handleAttendanceSearch}
                   setSearchAttendance={setSearchAttendance} setShow={setShow} show={show}
                    searchAttendance={searchAttendance} 
                   activeButton={activeButton}  placement="bottom" name="Open Bottom" />
                </div>
                <div className="EMP-all-employees-sheet col">
                  <div className="EMP-home-icon-sheet">
                    <BiHomeAlt className="EMP-home-icon-header-sheet" />
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-employee-text-sheet"> 
                    <p>Attendance</p>
                  </div>
                  <div className="EMP-arrow-icon-sheet">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="EMP-all-employee-text-sheet">
                    <p>Attendance Sheet</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="EMP-table-in-all-emplyee-sheet">
                <div className="top-legends-main">
                    <div className="attendance-sheet-before-legends">
                      <h2>Attendance Sheet</h2>
                    </div>
                    <div className="legends-section">
                      <div className="legends-inner">
                        <img
                          src={fullday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">P</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={holiday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Off</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={Properholiday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">H</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={leave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">A</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={HalfDayLeave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">HDL</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={shortleave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">SDL</p>
                      </div>

                      <div className="legends-inner">
                        <img
                          src={OutDoorLeave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">ODL</p>
                      </div>

                      <div className="legends-inner">
                        <img
                          src={SickLeave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">SL</p>
                      </div>

                      <div className="legends-inner">
                        <img
                          src={CasualLeave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">CL</p>
                      </div>

                    </div>
                  </div>

                  {/* <div className="top-legends-main">
                    <div className="attendance-sheet-before-legends">
                      <h2>Attendance Sheet</h2>
                    </div>
                    <div className="legends-section">
                      <div className="legends-inner">
                        <img
                          src={fullday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Present</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={holiday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Off Day</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={Properholiday}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Holiday</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={leave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Leave</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={HalfDayLeave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Half Day Leave</p>
                      </div>
                      <div className="legends-inner">
                        <img
                          src={shortleave}
                          alt="image"
                          className="legends-images"
                        />
                        <p className="legends-names">Short Leave</p>
                      </div>
                    </div>
                  </div> */}
                  <div className="calender-in-header row ">
                    <div className="col-4">
                      <div className="EMP-flash-floating-sheet col">
                        <label htmlFor=""> Choose start date </label>
                        <input
                          type="date"
                          name=""
                          id=""
                          value={searchAttendance?.startDate}
                          onChange={(e) =>
                            setSearchAttendance({
                              ...searchAttendance,
                              startDate: e?.target?.value,
                            })
                          }
                          max={currentDate}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="flash-floating-sheet col">
                        <label htmlFor=""> Choose end date </label>
                        <input
                          type="date"
                          name=""
                          id=""
                          value={searchAttendance?.endDate}
                          onChange={(e) =>
                            setSearchAttendance({
                              ...searchAttendance,
                              endDate: e?.target?.value,
                            })
                          }
                          min={searchAttendance?.startDate}
                          max={currentDate}
                        />
                      </div>
                    </div>
                    <div className=" EMP-search-button-sheet col-4">
                      {activeButton ||
                        (searchAttendance?.startDate &&
                          searchAttendance?.endDate) ? (
                        <div className=" EMP-search-button-sheet col-4">
                          <button
                            onClick={() => {
                              setSearchAttendance({
                                startDate: "",
                                endDate: "",
                                dayscount: "",
                              });
                              setActiveButton();
                              handleAttendanceSearch();
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="EMP-table-all-content-sheet">
                    {monthResult
                      ?.sort((a, b) =>
                        a?.[0]?.User?.UserName?.toLowerCase() >
                          b?.[0]?.User?.UserName?.toLowerCase()
                          ? 1
                          : -1
                      )
                      .map((e, index) => {
                        return (
                          < Fragment key={index}>
                            <div className="months-heading-for-table">
                              <p>
                                {`${monthsArray[
                                  new Date(e?.[0]?.Date)?.getMonth()
                                ]
                                  } ${new Date(e?.[0]?.Date)?.getFullYear()}`}
                              </p>
                            </div>
                            <table className="EMP-table-main-class">
                              <thead className="EMP-thead-main-class">
                                <tr className=" row"></tr>
                                <tr className="">
                                  <th>{e?.[0]?.User?.UserName}</th>
                                  {e?.map((item, index) => (
                                    <td
                                      key={index}
                                      className="date-and-day-data"
                                    >
                                      {new Date(item?.Date)?.toLocaleDateString(
                                        "en-US",
                                        {
                                          weekday: "short",
                                          day: "numeric",
                                        }
                                      )}
{/* 
                                      {item.InTime ?  
                                        <p
                                          onClick={() =>
                                            handlePencilClick(item)
                                          }
                                        >
                                          <FaEdit className="edit-icon-hr" />
                                        </p>: <p> <FaEdit className="edit-icon-hr-dummy" /> </p>
                                      } */}
                                       <p
                                          onClick={() =>
                                            handlePencilClick(item)
                                          }
                                        >
                                          <FaEdit className="edit-icon-hr" />
                                        </p>
                                    </td>
                                  ))}
                                </tr>
                              </thead>
                              <tbody className="EMP-tbody-main-class">
                                <tr>
                                  <td className="input-class-in-td-main ">
                                    <p className="attendance-label">
                                      Attendance
                                    </p>
                                    <p className="in-time-label">In time</p>
                                    <p className="outtime-label">Out time</p>
                                  </td>
                                  {e?.map((item, index) => (
                                    <td key={index}>
                                      {item?.DailyStatus?.length ? <>
                                        {item?.DailyStatus === "ShortLeave" && (
                                        <img
                                          src={shortleave}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      )}
                                      {item?.DailyStatus ===
                                            "CasualLeave" && (
                                            <img
                                              src={CasualLeave}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                           {item?.DailyStatus ===
                                            "SickLeave" && (
                                            <img
                                              src={SickLeave}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                      {item?.DailyStatus === "Holiday" && (
                                            <img
                                              src={Properholiday}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                           {item?.DailyStatus ===
                                            "Absent" && (
                                            <img
                                              src={leave}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                      {item?.DailyStatus === "FullDay" && (
                                        <img
                                          src={fullday}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      )}
                                            {item?.DailyStatus === "EarlyClosure" && (
                                        <img
                                          src={fullday}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      )}
                                      {item.DailyStatus === "WeeklyOFF" && (
                                        <img
                                        src={holiday}
                                        alt="image"
                                        className="legends-images"
                                      />
                                      )}
                                      {item?.DailyStatus === "Leave" && item.DailyStatus === "WeeklyOFF" && (
                                        <img
                                          src={leave}
                                          alt="Leave"
                                          className="legends-images"
                                        />
                                      )}

                                      {item?.DailyStatus === "HalfDayleave" && (
                                        <img
                                          src={HalfDayLeave}
                                          alt="image"
                                          className="legends-images"
                                        />)
                                      }
                                      {item.DailyStatus === "ShortLeave" === 2 &&
                                        <img
                                          src={HalfDayLeave}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      }
</> :  <> <div className="legends-images-new"> .</div></>}


                                      <p className="intime-for-attendance">
                                        {item?.InTime ? item?.InTime.substring(0, 5) : "-"}
                                      </p>
                                      <p className="out-for-attendance">
                                        {item?.InTime && item?.OutTime ? item?.OutTime.substring(0, 5) : "-"}
                                      </p>
                                      {/* {item?.DailyStatus === "ShortLeave" && (
                                        <img
                                          src={shortleave}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      )}
                                      {item?.DailyStatus === "FullDay" && (
                                        <img
                                          src={fullday}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      )}
                                      {item.Status === "WeeklyOff" && (
                                        <img
                                        src={holiday}
                                        alt="image"
                                        className="legends-images"
                                      />
                                      )}
                                      {item?.DailyStatus === "Leave" && item.Status !== "WeeklyOff" && (
                                        <img
                                          src={leave}
                                          alt="Leave"
                                          className="legends-images"
                                        />
                                      )}

                                      {item.DailyStatus === "HalfDay" && (

                                        <img
                                          src={HalfDayLeave}
                                          alt="image"
                                          className="legends-images"
                                        />)
                                      }
                                      {item.DailyStatus === "ShortLeave" === 2 &&
                                        <img
                                          src={HalfDayLeave}
                                          alt="image"
                                          className="legends-images"
                                        />
                                      } */}
                                    </td>
                                  ))}

                                </tr>
                              </tbody>
                            </table>
                          </Fragment>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header className="empAttendance" closeButton>
            <Modal.Title> Edit time</Modal.Title>
          </Modal.Header>

          <Modal.Body className="employee-Modal-body">
            <div>
              <div>
                <label htmlFor="">Date</label>
              </div>
              <div className="modal-DatePicker">
                <DatePicker
                  containerClassName="containerclass"
                  value={new Date(updateAttend.Date)}
                  onChange={(date) => { }}
                />
              </div>
            </div>
            <div className="update-attendance-time">
              <div>
                <label htmlFor="">In time</label>
                <DatePicker
                  containerClassName="time-change-in-hr-side"
                  value={Modaldata}
                  format="hh:mm A"
                  plugins={[<TimePicker />]}
                  disableDayPicker
                  onChange={(date) => setmodaldata(new Date(date))}
                />
              </div>
              <div>
                <label htmlFor="">Out time</label>
                <DatePicker
                  plugins={[<TimePicker />]}
                  format="hh:mm A"
                  containerClassName="time-change-in-hr-side"
                  value={modaldatanew}
                  disableDayPicker
                  onChange={(date) => setmodaldatanew(new Date(date))}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer className="empAttendance-footer">
            <button
              className="handleCloseModal-button"
              onClick={handleCloseModal}
            >
              Close
            </button>
            <button
              className="handleUpdateAttendance-button"
              onClick={handleUpdateAttendance}
            >

              Save
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default AttendanceSheet;
